// extracted by mini-css-extract-plugin
export default {"footer":"profile_footer__YkQSC"};